import React, { useState } from "react";
import { Modal } from "../../../../components/Modal/index";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { updateActiveAtencionItems, linkMultipleTreatmentsToAtencion } from "../../../../redux/atenciones/atencionesActions";
import { actualizarNotas, iniciarPrestacionTrx } from "../../../../redux/prestation/prestationActions";
import {
  Tabla,
  TablaHeader,
  TablaHeaderTexto,
  ButtonAddBenefit,
  TablaBody,
  ContainerTitle,
  ContainerTitleText,
  ContainerBody,
  TablaBodyTexto,
  TablaBodyTextoDiente,
  ScrollDiv,
} from "./styles";



import { CardModal } from "./styles";
const useActivas = () => {
  const prestaciones = useSelector((state) => state.prestaciones);
  let prestacionesActivas = { items: [] };
  if (prestaciones.items) {
    prestacionesActivas.items = prestaciones.items.filter(
      (prestacion) => prestacion.estado == "ACTIVO" || prestacion.estado == "PENDIENTE"
    );
  }

  return [prestacionesActivas];
};
const usePrestacionesParaSesion = () => {
  const [prestaciones] = useActivas();

  const atencionActiva = useSelector((state) => state.atenciones.atencionActiva);
  // todas las prestaciones que no estan en la sesion
  let prestacionesParaSesion = Object.assign({}, prestaciones);
  const sessionItems = atencionActiva?.items || [];

  if (prestaciones?.items) {
    prestacionesParaSesion.items = prestaciones.items.filter((pa) => {
      // Filtrar solo las que no estan en la sesion actual
      return !sessionItems.includes(pa.id);
    });
  } else {
    prestacionesParaSesion.items = [];
  }

  // Eliminamos la logica de mutacion de checked aqui
  
  return [prestacionesParaSesion];
};

export const PrestacionSeleccionModal = (props) => {
  const dispatch = useDispatch();
  const sesion = useSelector((state) => state.sesion);
  const atencionActiva = useSelector((state) => state.atenciones.atencionActiva);
  const paciente = useSelector((state) => state.paciente);
  const cuenta = useSelector((state) => state.cuenta);
  const { addToast } = useToasts();

  const [prestacionesParaSesion] = usePrestacionesParaSesion();
  
  // State for selection management
  const [selectedIds, setSelectedIds] = useState([]);

  const toDate = (fecha) => {
    let f = new Date(fecha);
    const a = f.getFullYear();
    const m = (f.getMonth() + 1).toString().padStart(2, "0");
    const d = f.getDate().toString().padStart(2, "0");
    return `${a}-${m}-${d}`;
  };

  const handleCheckboxChange = (e) => {
    const id = e.target.id;
    const isChecked = e.target.checked;
    
    setSelectedIds(prev => {
        if (isChecked) {
            return [...prev, id];
        } else {
            return prev.filter(itemId => itemId !== id);
        }
    });
  };

  const handleAddToSession = async () => {
    // Validamos primero qué se va a agregar
    // Necesitamos los objetos completos para la logica de notas
    const itemsToAdd = prestacionesParaSesion.items.filter(item => selectedIds.includes(item.id));

    // To avoid refactoring the entire legacy logic inside the loop, we'll iterate the items matches
    const itemsSelectedObjects = prestacionesParaSesion.items.filter(item => selectedIds.includes(item.id));

    itemsSelectedObjects.forEach((prestacion) => {
        // Mantener logica legacy de nota clinica en la prestacion
        const nota = {
          fecha: Date.now(),
          nota: "Atendida",
          especialista: sesion.usuario.email,
        };

        let existeNota = prestacion.notasClinicas?.some(
          (nota) =>
            toDate(nota.fecha) === sesion.fecha && nota.nota === "Atendida"
        );

        if (!existeNota) {
          if (!prestacion.notasClinicas) prestacion.notasClinicas = [];
          prestacion.notasClinicas.unshift(nota);
          // Esta accion es async independiente
          dispatch(actualizarNotas(prestacion));
        }
    });

    if (selectedIds.length > 0) {
      try {
        await dispatch(linkMultipleTreatmentsToAtencion(paciente.id, atencionActiva.id, selectedIds, sesion.usuario.email));
        addToast("Prestaciones agregadas correctamente", { appearance: "success" });
        setSelectedIds([]); // Reset selection
        props.handleCloseModal();
      } catch (error) {
        console.error("Error linking treatments:", error);
        addToast("Error al agregar prestaciones: " + error.message, { appearance: "error" });
      }
    } else {
      props.handleCloseModal();
    }
  };

  return (
    <Modal isOpen={props.isOpen} onClose={props.handleCloseModal}>
      <React.Fragment>
        <ContainerTitle>
          <ContainerTitleText>
            Seleccione prestaciones atender
          </ContainerTitleText>
        </ContainerTitle>
        <ContainerBody>
          <CardModal>
            <div className="cardnav__left"></div>
            <div className="cardnav__right">
              <ButtonAddBenefit onClick={handleAddToSession}>
                Aceptar
              </ButtonAddBenefit>
              <br />
            </div>
          </CardModal>
          <ScrollDiv>
            <Tabla>
              <TablaHeader>
                <tr>
                  <TablaHeaderTexto scope="col">Prestación</TablaHeaderTexto>
                  <TablaHeaderTexto scope="col">Diente</TablaHeaderTexto>
                  <TablaHeaderTexto scope="col">Saldo</TablaHeaderTexto>
                  <TablaHeaderTexto scope="col">Selección</TablaHeaderTexto>
                </tr>
              </TablaHeader>
              <TablaBody>
                {prestacionesParaSesion.items?.map((item) => {
                  return (
                    <Fila 
                        item={item} 
                        onChange={handleCheckboxChange} 
                        key={item.id} 
                        checked={selectedIds.includes(item.id)}
                    />
                  );
                })}
              </TablaBody>
            </Tabla>
          </ScrollDiv>
        </ContainerBody>
      </React.Fragment>
    </Modal>
  );
};

const Fila = ({ item, onChange, checked }) => {
  return (
    <tr key={item.id}>
      <TablaBodyTexto>{`${item.tratamiento} ${item.tipo ? item.tipo : ""
        }`}</TablaBodyTexto>
      <TablaBodyTextoDiente>{item.dientes}</TablaBodyTextoDiente>
      <TablaBodyTexto>{item.saldo}</TablaBodyTexto>
      <TablaBodyTexto>
        <input
          type="checkbox"
          id={item.id}
          name={item.tratamiento}
          onChange={onChange}
          checked={checked}
        />
      </TablaBodyTexto>
    </tr>
  );
};
